import styled from 'styled-components'
import { StyledComponentType } from 'types/style'
import zLayers from 'utils/styling/zLayers'

type ContainerProps = {
  height: number
  width: number
}

type FrameProps = {
  color: string
  leftMargin?: number
  rightMargin?: number
  topMargin?: number
  bottomMargin?: number
  thickness?: number
}

type FoldFrameProps = {
  color: string
  center: number
  thickness: number
  topMargin: number
  bottomMargin: number
}

type CornerProps = {
  color: string
  thicknessTop?: number
  thicknessRight?: number
  thicknessBottom?: number
  thicknessLeft?: number
}

export const Container: StyledComponentType<'div', ContainerProps> =
  styled.div<ContainerProps>`
    position: absolute;
    top: 0;
    left: 0;
    height: ${({ height }) => `${height}px`};
    width: ${({ width }) => `${width}px`};
    display: flex;
    z-index: ${zLayers.overlayTop};
    pointer-events: none;
  `

export const TopFrame: StyledComponentType<'div', FrameProps> =
  styled.div<FrameProps>`
    position: absolute;
    top: 0;
    left: ${({ leftMargin = 0 }) => `${leftMargin}px`};
    right: ${({ rightMargin = 0 }) => `${rightMargin}px`};
    height: ${({ topMargin = 0 }) => `${topMargin}px`};
    background: ${({ color }) => color};
  `

export const RightFrame: StyledComponentType<'div', FrameProps> =
  styled.div<FrameProps>`
    position: absolute;
    top: ${({ topMargin = 0 }) => `${topMargin}px`};
    right: 0;
    bottom: ${({ bottomMargin = 0 }) => `${bottomMargin}px`};
    width: ${({ rightMargin = 0 }) => `${rightMargin}px`};
    background: ${({ color }) => color};
  `

export const BottomFrame: StyledComponentType<'div', FrameProps> =
  styled.div<FrameProps>`
    position: absolute;
    bottom: 0;
    left: ${({ leftMargin = 0 }) => `${leftMargin}px`};
    right: ${({ rightMargin = 0 }) => `${rightMargin}px`};
    height: ${({ bottomMargin = 0 }) => `${bottomMargin}px`};
    background: ${({ color }) => color};
  `

export const LeftFrame: StyledComponentType<'div', FrameProps> =
  styled.div<FrameProps>`
    position: absolute;
    top: ${({ topMargin = 0 }) => `${topMargin}px`};
    left: 0;
    bottom: ${({ bottomMargin = 0 }) => `${bottomMargin}px`};
    width: ${({ leftMargin = 0 }) => `${leftMargin}px`};
    background: ${({ color }) => color};
  `

export const TopLeftCorner: StyledComponentType<'div', CornerProps> =
  styled.div<CornerProps>`
    position: absolute;
    top: 0;
    left: 0;
    width: ${({ thicknessLeft = 0 }) => `${thicknessLeft}px`};
    height: ${({ thicknessTop = 0 }) => `${thicknessTop}px`};
    background: ${({ color }) => color};
  `

export const TopRightCorner: StyledComponentType<'div', CornerProps> =
  styled.div<CornerProps>`
    position: absolute;
    top: 0;
    right: 0;
    width: ${({ thicknessRight = 0 }) => `${thicknessRight}px`};
    height: ${({ thicknessTop = 0 }) => `${thicknessTop}px`};
    background: ${({ color }) => color};
  `

export const BottomLeftCorner: StyledComponentType<'div', CornerProps> =
  styled.div<CornerProps>`
    position: absolute;
    bottom: 0;
    left: 0;
    width: ${({ thicknessLeft = 0 }) => `${thicknessLeft}px`};
    height: ${({ thicknessBottom = 0 }) => `${thicknessBottom}px`};
    background: ${({ color }) => color};
  `

export const BottomRightCorner: StyledComponentType<'div', CornerProps> =
  styled.div<CornerProps>`
    position: absolute;
    bottom: 0;
    right: 0;
    width: ${({ thicknessRight = 0 }) => `${thicknessRight}px`};
    height: ${({ thicknessBottom = 0 }) => `${thicknessBottom}px`};
    background: ${({ color }) => color};
  `

export const VerticalCenterFrame: StyledComponentType<'div', FrameProps> =
  styled.div<FrameProps>`
    position: absolute;
    top: ${({ topMargin = 0 }) => `${topMargin}px`};
    bottom: ${({ bottomMargin = 0 }) => `${bottomMargin}px`};
    left: 50%;
    transform: translateX(-50%);
    width: ${({ thickness }) => `${thickness}px`};
    background: ${({ color }) => color};
  `

export const HorizontalCenterFrame: StyledComponentType<'div', FrameProps> =
  styled.div<FrameProps>`
    position: absolute;
    left: ${({ leftMargin = 0 }) => `${leftMargin}px`};
    right: ${({ rightMargin = 0 }) => `${rightMargin}px`};
    top: 50%;
    transform: translateY(-50%);
    height: ${({ thickness }) => `${thickness}px`};
    background: ${({ color }) => color};
  `

export const FoldFrame: StyledComponentType<'div', FoldFrameProps> =
  styled.div<FoldFrameProps>`
    position: absolute;
    top: ${({ topMargin }) => `${topMargin}px`};
    bottom: ${({ bottomMargin }) => `${bottomMargin}px`};
    left: ${({ center }) => `${center}px`};
    transform: translateX(-50%);
    width: ${({ thickness }) => `${thickness}px`};
    background: ${({ color }) => color};
  `
